import type { TAbsoluteLocale, TRegionDetail } from '@src/config/localisation/locale-config.types'
import { parseLocale } from '@src/utils/i18n.utils'

import { REGION_RUM_CONTEXT_KEYS } from './region-rum.constants'
import { setRumGlobalContext } from './rum.helper'

/**
 * Stamps the shopper's region onto RUM global context (`@context.region` = US/CA/GB)
 * from the request locale; `region_id` is added when the region resolves.
 */
export const setRegionRumContext = (locale?: TAbsoluteLocale, regionDetails?: TRegionDetail): void => {
  if (!locale || !regionDetails) return
  try {
    const { country } = parseLocale(locale)
    const regionId = regionDetails.regions[country]?.regionId
    setRumGlobalContext({
      [REGION_RUM_CONTEXT_KEYS.REGION]: country?.toUpperCase(),
      [REGION_RUM_CONTEXT_KEYS.REGION_ID]: regionId != null ? String(regionId) : undefined,
    })
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}
